// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"163":"map","187":"search"}[chunkId] + "." + {"163":"405d68ed","187":"3f2dd792"}[chunkId] + ".chunk.css";
};